module.exports = __webpack_public_path__ + "static/aime_balloons-24d034aa4ea6af28520883fe02fe7804.png";